import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dateFormat, getWholeWeek } from "../utils/utilities";
import { calendarSvg, leftArrowSvg, rightArrowSvg } from "../assets/svg";
import {
    updateAppointment,
    updateDate,
} from "../Redux/Reducers/appointmentFilterSlice";
import Calendar from "./Calendar";

function AppointmentDate() {
    const dispatch = useDispatch();
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);

    const selectedAppointment = useSelector(
        (state) => state.appointment.selectedAppointment
    );

    const selectedDateISOString = useSelector(
        (state) => state.appointment.selectedDate
    );

    const [days, setDays] = useState();
    const selectedDate = useMemo(
        () => new Date(selectedDateISOString),
        [selectedDateISOString]
    );

    const handleMonthChange = (value) => {
        const newDate = new Date(selectedDate);
        newDate.setMonth(newDate.getMonth() + value);
        dispatch(updateDate(newDate.toISOString()));
    };

    useEffect(() => {
        setDays(getWholeWeek(selectedDate));
        if (selectedAppointment.time) {
            dispatch(
                updateAppointment({
                    time: null,
                    duration: null,
                    date: null,
                    identification: null,
                    type: null,
                })
            );
        }
    }, [selectedDate]);

    return (
        <div>
            <div className="d-flex f500-16px">
                <div>Selected Date</div>
                <div
                    className="d-flex gap-lg-2 ms-2 cursor-pointer"
                    style={{ color: "rgba(84, 100, 99, 1)" }}
                >
                    <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleMonthChange(-1)}
                    >
                        {leftArrowSvg({})}
                    </div>
                    <div className="text-decoration-underline">
                        {dateFormat(selectedDate)?.month +
                            " " +
                            dateFormat(selectedDate)?.year}
                    </div>
                    <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleMonthChange(1)}
                    >
                        {rightArrowSvg({})}
                    </div>
                </div>
            </div>
            <div className="d-flex gap-1 gap-lg-4">
                {days?.map((day, index) => (
                    <div
                        key={index}
                        className={`date-button f500-14px ${
                            selectedDate.getDate() ===
                            new Date(day.date).getDate()
                                ? "active-date-button"
                                : ""
                        }`}
                        onClick={() =>
                            dispatch(
                                updateDate(new Date(day.date).toISOString())
                            )
                        }
                    >
                        <div>{day.day.slice(0, 3)}</div>
                        <div>{new Date(day.date).getDate()}</div>
                    </div>
                ))}
                <div className="position-relative">
                    <div
                        className="date-button custom-calendar-btn"
                        onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                    >
                        {calendarSvg({})}
                    </div>
                    <div
                        className="calendar-section"
                        style={{
                            display: isCalendarOpen ? "block" : "none",
                            zIndex: isCalendarOpen ? 1 : 'auto',
                        }}
                    >
                        <Calendar
                            onDateChange={(date) => {
                                dispatch(
                                    updateDate(new Date(date).toISOString())
                                );
                                // Keep the calendar open when a date is selected.
                                setIsCalendarOpen(false);
                            }}
                            onMonthChange={() => {
                                // Keep the calendar open when the month is changed.
                                setIsCalendarOpen(true);
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AppointmentDate;
